<template>
  <div
    class="modal fade"
    id="shopperApprovalMap"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            aria-hidden="true"
            @click="closeModal"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <GoogleMaps
            ref="approvalGmaps"
            :checkList="checkList"
            :proposalList="proposalList"
            :currentFilterObject="null"
          ></GoogleMaps>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleMaps from "./GoogleMaps";

export default {
  name: "ShopperApprovalMap",
  components: {
    GoogleMaps
  },
  props: {
    checkList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      lang: {}
    }
  },
  computed: {
    proposalList() {
      var res = [];
      this.checkList.forEach(check => {
        if(check.ShopperProposals) {
          check.ShopperProposals.forEach(proposal => {
            proposal.SurveyInstanceId = check.SurveyInstanceId;
            res.push(proposal);
          })
        }

      });
      return res;
    }
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.openModal();
  },
  methods: {
    openModal() {
      $("#shopperApprovalMap").modal("show");
    },
    closeModal() {
      $("#shopperApprovalMap").modal("hide");
      this.$emit("close")
    }
  }
}
</script>

<style scoped>
.modal-lg {
  width: 80vw;
}
</style>


// WEBPACK FOOTER //
// ShopperApprovalMap.vue?08c2b6b1